import { Component } from '@angular/core';

@Component({
  selector: 'mprd-mymail-skeleton-mailboxes',
  templateUrl: './skeleton-mailboxes.component.html',
})
export class SkeletonMailboxesComponent {
  constructor() {}
}
